/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { CvDto } from '../models/cv-dto';
import { CvImageDto } from '../models/cv-image-dto';
import { MasterDataDto } from '../models/master-data-dto';

@Injectable({
  providedIn: 'root',
})
export class MasterDataRestControllerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getMasterData
   */
  static readonly GetMasterDataPath = '/api/v1/masterdata';

  /**
   * Provides the list of all master data.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getMasterData()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMasterData$Response(params?: {
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Array<MasterDataDto>>> {

    const rb = new RequestBuilder(this.rootUrl, MasterDataRestControllerService.GetMasterDataPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<MasterDataDto>>;
      })
    );
  }

  /**
   * Provides the list of all master data.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getMasterData$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMasterData(params?: {
  },
  context?: HttpContext

): Observable<Array<MasterDataDto>> {

    return this.getMasterData$Response(params,context).pipe(
      map((r: StrictHttpResponse<Array<MasterDataDto>>) => r.body as Array<MasterDataDto>)
    );
  }

  /**
   * Path part for operation createOrUpdateMasterData
   */
  static readonly CreateOrUpdateMasterDataPath = '/api/v1/masterdata';

  /**
   * Creates / Updates master data.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createOrUpdateMasterData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  createOrUpdateMasterData$Response(params: {
    cvId: number;
    body?: {
'file'?: Blob;
'masterdata': MasterDataDto;
}
  },
  context?: HttpContext

): Observable<StrictHttpResponse<CvDto>> {

    const rb = new RequestBuilder(this.rootUrl, MasterDataRestControllerService.CreateOrUpdateMasterDataPath, 'post');
    if (params) {
      rb.query('cvId', params.cvId, {});
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CvDto>;
      })
    );
  }

  /**
   * Creates / Updates master data.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createOrUpdateMasterData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  createOrUpdateMasterData(params: {
    cvId: number;
    body?: {
'file'?: Blob;
'masterdata': MasterDataDto;
}
  },
  context?: HttpContext

): Observable<CvDto> {

    return this.createOrUpdateMasterData$Response(params,context).pipe(
      map((r: StrictHttpResponse<CvDto>) => r.body as CvDto)
    );
  }

  /**
   * Path part for operation getMasterDataById
   */
  static readonly GetMasterDataByIdPath = '/api/v1/masterdata/{id}';

  /**
   * Provides master data based on given ID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getMasterDataById()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMasterDataById$Response(params: {
    id: number;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<MasterDataDto>> {

    const rb = new RequestBuilder(this.rootUrl, MasterDataRestControllerService.GetMasterDataByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<MasterDataDto>;
      })
    );
  }

  /**
   * Provides master data based on given ID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getMasterDataById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMasterDataById(params: {
    id: number;
  },
  context?: HttpContext

): Observable<MasterDataDto> {

    return this.getMasterDataById$Response(params,context).pipe(
      map((r: StrictHttpResponse<MasterDataDto>) => r.body as MasterDataDto)
    );
  }

  /**
   * Path part for operation getCvImage
   */
  static readonly GetCvImagePath = '/api/v1/masterdata/{id}/image';

  /**
   * Retrieve the cv image.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCvImage()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCvImage$Response(params: {
    id: number;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<CvImageDto>> {

    const rb = new RequestBuilder(this.rootUrl, MasterDataRestControllerService.GetCvImagePath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CvImageDto>;
      })
    );
  }

  /**
   * Retrieve the cv image.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCvImage$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCvImage(params: {
    id: number;
  },
  context?: HttpContext

): Observable<CvImageDto> {

    return this.getCvImage$Response(params,context).pipe(
      map((r: StrictHttpResponse<CvImageDto>) => r.body as CvImageDto)
    );
  }

}
